import React from "react";
import { Img } from "../../core/design-system/Img";
import { useSelector } from "react-redux";
import { selectAccount } from "../../dashboard/redux/accountSlice";
import { useNavigate } from "react-router-dom";
import useTailwindBreakpoints from "../../../hooks/useTailwindBreakPoints";
import { Text } from "../../core/design-system/Text";

interface AccountHeaderProps {
  // Define your prop types here
}

const AccountHeader: React.FC<AccountHeaderProps> = (props) => {
  const account = useSelector(selectAccount);
  const navigate = useNavigate();
  const { xl } = useTailwindBreakpoints();
  return (
    <div className="flex flex-row justify-between h-[13.94rem] bg-accountHeader">
      <div className="flex pt-10 pb-8 px-8 ">
        <div className="flex flex-col justify-between w-full items-start gap-12">
          <div
            className="flex flex-row items-center gap-2 hover:cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <Img
              src={"img_arrow_right_white.svg"}
              alt="arrow"
              className="w-6 h-6 rotate-180 "
            />

            <p className="text-primaryForeground text-[1.5rem] xs:font-medium 4xl:font-normal text-left">
              {account?.value.name}
            </p>
          </div>

          <div className="flex flex-row gap-[calc(100vw/10)] w-full">
            <div className="flex flex-col  items-start gap-1">
              <Text className="text-lightGray !text-xl 5xl:!text-2xl 5xl:mb-2 xs:font-medium 4xl:font-normal opacity-60 leading-6">
                Balance
              </Text>
              <Text className="text-white lg:text-2xl  xl:text:xl 2xl:text-[2rem] 3xl:text-3xl text-left xs:font-medium 5xl:font-normal text-white-A700 leading-6">
                {account?.value.balanceLcyFormatted ?? "AED 0"}
              </Text>
            </div>

            <div className="flex flex-row gap-16 items-center justify-center px-5 py-2.5 rounded-lg bg-accountDetailsContainer">
              <div className="flex flex-col  items-start">
                <Text className="text-lightGray xs:!text-sm 5xl:!text-lg opacity-60 leading-6 4xl:font-normal">
                  Account Holder Name
                </Text>
                <Text className="text-white xs:!text-lg 5xl:!text-xl  xs:font-medium 4xl:font-normal  text-white-A700 leading-6">
                  {account?.value.customerName ?? "John Doe"}
                </Text>
              </div>
              <div className="flex flex-col items-start">
                <Text className="text-lightGray xs:!text-lg 5xl:!text-xl xs:font-medium 4xl:font-normal opacity-50 leading-6">
                  Account Number
                </Text>
                <Text className="text-white xs:!text-lg 5xl:!text-xl xs:font-medium 4xl:font-normal text-white-A700 leading-6">
                  *** {account?.value.id.slice(30)}
                </Text>
              </div>
              <div className="flex flex-col items-start">
                <Text className="text-lightGray xs:!text-lg 5xl:!text-xl xs:font-medium 4xl:font-normal opacity-50 leading-6">
                  Branch
                </Text>
                <Text className="text-white m-0 xs:!text-lg 5xl:!text-xl xs:font-medium 4xl:font-normal text-white-A700  leading-6">
                  {account?.value.branch ?? "Dubai"}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      {xl && (
        <Img
          src={"pngwing.png"}
          alt="Account"
          className=" xs:w-[22.125rem] 4xl:w-[30rem]  5xl:w-[40rem] h-full object-cover"
        />
      )}
    </div>
  );
};

export default AccountHeader;
